module.exports = __webpack_public_path__ + "img/gift.c388bfe0.svg";